import styled from 'styled-components';
import { themed } from '@/shared/ui/core';

export const SelectGroupBy = styled.div.attrs({
  className: 'SelectGroupByStyled',
})`
  position: relative;
`;

export const Select = styled.details`
  border: 1px solid ${themed('common.borderColor')};
  border-radius: 4px;

  &[disabled],
  &[readonly] {
    background-color: ${themed('primary.lightGray')};
  }

  &[disabled] summary,
  &[readonly] summary,
  summary select {
    pointer-events: none;
    user-select: none;
  }
`;

export const Placeholder = styled.summary`
  align-items: center;
  color: ${({ optionSelected }) => !optionSelected ? themed('primary.darkGray') : themed('primary.text')};
  display: flex;
  font-size: 0.875rem;
  justify-content: space-between;
  letter-spacing: 0.015rem;
  line-height: 0.875rem;
  padding: 0.8721rem;

  select {
    appearance: none;
    background: transparent;
    border: 0;
    margin-bottom: 0 !important;
    padding: 0;
    height: auto;
  }
`;

export const IconWrapper = styled.div`
  width: 0.75rem;

  svg {
    display: block;
    margin: auto;
    stroke: #000;
    stroke-width: 1rem;
    width: 0.75rem;
  }
`;

export const SelectOverlay = styled.div`
  background-color: white;
  border: 1px solid ${themed('common.borderColor')};
  display: flex;
  flex-direction: column;
  left: 0;
  padding-top: 1rem;
  position: absolute;
  top: 4.45rem;
  width: 100%;
  z-index: 999;

  .Title {
    font-size: 1.25rem;
    font-weight: bold;
    padding: 0.225rem 1rem;
  }
`;

export const Option = styled.button.attrs({
  type: 'button',
  role: 'option',
})`
  background-color: transparent;
  border: 0;
  font-size: 0.875rem;
  letter-spacing: 0.015rem;
  line-height: 1.125rem;
  padding: 1rem;
  text-align: left;

  &:hover {
    background-color: #e8fafe;
    font-weight: bold;
  }
`;
